// extracted by mini-css-extract-plugin
export var actions = "_4w-0";
export var actionsContainer = "_4w-7";
export var border = "_4w-1";
export var childFullHeight = "_4w-f";
export var collapse = "_4w-2";
export var content = "_4w-a";
export var contentChild = "_4w-e";
export var fullscreen = "_4w-c";
export var hasLeftRadius = "_4w-k";
export var headerContainer = "_4w-3";
export var headerRow = "_4w-5";
export var hidePadding = "_4w-b";
export var navCollapsedGap = "_4w-l";
export var noScrollX = "_4w-m";
export var noScrollY = "_4w-n";
export var noTopPadding = "_4w-i";
export var optOutTopPadding = "_4w-d";
export var pageMain = "_4w-j";
export var pageOuter = "_4w-g";
export var pagePadding = "_4w-8";
export var pageScroll = "_4w-9";
export var profile = "_4w-o";
export var profileContainer = "_4w-p";
export var profileImage = "_4w-q";
export var profileMain = "_4w-r";
export var profileSubtitle = "_4w-t";
export var profileTitle = "_4w-s";
export var showLeftPadding = "_4w-h";
export var tabsPortalSlot = "_4w-6";
export var tabsWrapper = "_4w-4";
export var title = "_4w-u";